import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import { XSymbol } from '../../../assets/xSymbol';
const X_SYMBOL_CONTAINER_CSS = css `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
export const ColorSwatchButton = ({ colorString, onClick, isAllowed }) => {
    return (_jsx("div", { css: css `
        user-select: none;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: ${colorString};
        padding: 10px;
        min-width: 30px;
        min-height: 30px;
        color: ${color(colorString).luminosity() <= 0.33 ? 'white' : 'black'};
        border: 1px solid ${colorString};
        ${isAllowed &&
            css `
          cursor: pointer;
          &:hover {
            border-color: white;
          }
        `}
      `, onClick: isAllowed ? onClick : undefined, children: isAllowed ? (' ') : (_jsx("div", { css: X_SYMBOL_CONTAINER_CSS, children: _jsx(XSymbol, {}) })) }));
};
